import styled from 'styled-components'

const FloatingIcon = styled.img`
  height: 24px;
  width: 24px;
`

export default FloatingIcon
